import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiService } from 'services/ApiService';

const BootstrapRoute: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const run = async () => {
      try {
        const me = await ApiService.getMe();
        if (me.isArtist && me.artistId) {
          navigate(`/artist/${me.artistId}`, { replace: true });
        } else {
          navigate('/home', { replace: true });
        }
      } catch (e) {
        console.error('Bootstrap failed', e);
        navigate('/login', { replace: true });
      }
    };

    void run();
  }, [navigate]);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }

  return <div className="min-h-screen flex items-center justify-center text-gray-600">Loading...</div>;
};

export default BootstrapRoute;
